import React, { useEffect, useState } from "react";
import DataTableMD from "../core/dataTableMD";
import { getPeopleColumns, getPeopleFilters } from "./configs/peopleDataTableConfig";

/**
 * FEAT-044 (D21 / GH #124) — Unified People (staff) management screen.
 *
 * Replaces the per-role Responders / Super Admins pages with ONE role-filtered view over the
 * `peoples` table (type=user). No hardcoded permission filter — all staff are listed, filterable
 * by Role + scope. Students remain a separate persona view. Server-side tenant scoping still limits
 * a school/district admin to their own scope.
 */
const PeoplePage = () => {
  const [filters, setFilters] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const load = async () => {
      setFilters(await getPeopleFilters());
      setColumns(await getPeopleColumns());
    };
    load();
  }, []);

  const addSuccessMessage = "The new user has been successfully added to the system.";
  return (
    <DataTableMD
      title="People"
      dbTable="users"
      filters={filters}
      columns={columns}
      addButton={true}
      addSuccessMessage={addSuccessMessage}
      sort={{ field: "firstName", order: "asc" }}
    />
  );
};

export default PeoplePage;
